import React from 'react';
import Flag from 'components/Flag';
import { Space } from 'antd';

const Language = ({ language, languageName, countryName, locale }) => ((language || locale) ? (
  <Space>
    <Flag locale={locale || language} />
    <span>
      {languageName || language}
    </span>
    {countryName && (
      <span>
        (
        {countryName}
        )
      </span>
    )}
  </Space>
) : null);

export default Language;
